import React from "react";
import { Box, TextField, Button, Stack } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import useAuth from "../../hooks/useAuth";
import { createRole } from "../../api/roles";

const RoleForm = ({ onSuccess, onCancel }) => {
  const { user } = useAuth();
  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      permissions: [],
      tenant_id: user?.tenant_id,
    },
    validationSchema: yup.object({
      name: yup.string().required("Required"),
      description: yup.string().required("Required"),
    }),
    onSubmit: async (values) => {
      try {
        const newRole = await createRole(values);
        onSuccess(newRole);
      } catch (error) {
        console.error("Failed to create role:", error);
      }
    },
  });

  return (
    <Box component="form" onSubmit={formik.handleSubmit} sx={{ mt: 2 }}>
      <TextField
        fullWidth
        label="Role Name"
        name="name"
        value={formik.values.name}
        onChange={formik.handleChange}
        error={formik.touched.name && Boolean(formik.errors.name)}
        helperText={formik.touched.name && formik.errors.name}
        sx={{ mb: 2 }}
      />

      <TextField
        fullWidth
        multiline
        rows={3}
        label="Description"
        name="description"
        value={formik.values.description}
        onChange={formik.handleChange}
        error={formik.touched.description && Boolean(formik.errors.description)}
        helperText={formik.touched.description && formik.errors.description}
        sx={{ mb: 2 }}
      />

      <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
        <Button type="submit" variant="contained">
          Create Role
        </Button>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
      </Stack>
    </Box>
  );
};

export default RoleForm;
